import { toEditorMentions, } from '@debbie/common/dist/templates/suggestions.js';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { PARSE_RESULT_TYPE, encodeText, parseText } from '../utils/templates.js';
import NewEditor from './editor/Editor.js';
import { useEditorState } from './editor/hooks.js';
import { Button } from './index.js';
const WYSIWYGEditor = (props) => {
    const editorRef = useRef(null);
    const lang = useSelector((s) => s.lang);
    const editorState = useEditorState(encodeText(props.html || '', props.mentionSuggestions || []));
    useEffect(() => {
        if (props.autoFocus && editorRef && editorRef.current) {
            // @ts-ignore
            editorRef.current?.focusEditor();
        }
    }, [editorRef]);
    useEffect(() => {
        if (props.html) {
            editorState.overwriteEditorContent(encodeText(props.html || '', props.mentionSuggestions || []));
        }
    }, [props.html]);
    return (React.createElement(WYSIWYGEditorWrapper, { hideToolbar: props.hideToolbar },
        React.createElement(NewEditor, { mentions: toEditorMentions(props.mentionSuggestions ?? []), onChange: editorState.onChange, initialContent: editorState.editorContent }),
        React.createElement("br", null),
        React.createElement(Button, { block: true, loading: props.loading, onClick: () => {
                props.onChange(parseText(editorState.html, props.mentionSuggestions || [], PARSE_RESULT_TYPE.HTML));
            } }, lang.inputs.save)));
};
export default WYSIWYGEditor;
const WYSIWYGEditorWrapper = styled.div `
  ${(props) => props.hideToolbar
    ? `
      .rdw-editor-toolbar {
        display: none;
        position: sticky;
        top: 0px;
        z-index: 999;
      }
      .rdw-editor-wrapper {
        .rdw-editor-main {
          min-height: 45px;
          border-top: 1px solid #ccc;
          border-top-left-radius: 3px;
          border-top-right-radius: 3px;

          .public-DraftStyleDefault-block {
            margin: 0;
          }
        }
      }
    `
    : ''}
`;
//# sourceMappingURL=WYSIWYGEditor.js.map